// extracted by mini-css-extract-plugin
export default {"sizeTxt":"AddPhotos-module--sizeTxt--WkmWS","sizeImg":"AddPhotos-module--sizeImg--PKJJT","sizeImgCompany":"AddPhotos-module--sizeImgCompany--KBg9Y"};